export const RadioInput = {
  opacity: '0',
  position: 'absolute',

  ':focus + span::before': {
    borderColor: 'primary',
  },
  ':checked + span::before': {
    boxShadow: 'inset 0 0 0 0.1em white',
    backgroundColor: 'primary',
  },
  ':disabled + span::before': {
    backgroundColor: 'muted',
    cursor: 'not-allowed',
  },
};

export const RadioInputReplacement = {
  '::before': {
    content: '""',
    backgroundColor: 'white',
    borderRadius: '100%',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'gray.4',
    display: 'inline-block',
    position: 'relative',
    top: '0.1em',
    width: '1em',
    height: '1em',
    cursor: 'pointer',
    transition: 'all 300ms ease-in-out',
  },
};
